import React from 'react';
import { Card, CardBody, Table } from 'reactstrap';
import LenderPreview from './MortgagesModal/LenderPreview/LenderPreview';
const nl2br = require('react-nl2br');

export default props => {
  const { evidence_of_insurance_form } = props.entity;
  const isCognito = evidence_of_insurance_form !== null;
  return (
    <Card className={'h-100 card-form'}>
      <CardBody>
        <div className={'font-md color-blue'}>
          <span className={'text-capitalize'}>
            Mortgages / Additional Interest
          </span>
          {!isCognito && <button onClick={props.toggle}>Edit</button>}
          {isCognito && <button onClick={props.toggleCognito}>Edit</button>}
        </div>
        <div className={'pt-2 content'}>
          <Table size={'sm'} borderless>
            <tbody>
              <tr>
                <th className={'w-25'}>Escrow #</th>
                <td>{props.entity.escrow_number}</td>
              </tr>
              {props.entity.loan_number_1 !== null && (
                <tr>
                  <th className={'w-25'}>1st Loan #</th>
                  <td>{props.entity.loan_number_1}</td>
                </tr>
              )}
              {isCognito &&
                evidence_of_insurance_form.first_mortgage_clause !== null &&
                evidence_of_insurance_form.first_mortgage_clause.length > 0 && (
                  <tr>
                    <th>Lender</th>
                    <td className={'pb-3'}>
                      {nl2br(evidence_of_insurance_form.first_mortgage_clause)}
                    </td>
                  </tr>
                )}
              {props.entity.mortgage_id_1 !== null &&
                props.entity.first_mortgage !== null && (
                  <tr>
                    <th>Lender</th>
                    <td className={'pb-3'}>
                      <LenderPreview
                        {...props.entity.first_mortgage}
                        link={true}
                      />
                    </td>
                  </tr>
                )}

              {props.entity.loan_number_2 !== null && (
                <tr>
                  <th className={'w-25'}>2nd Loan #</th>
                  <td>{props.entity.loan_number_2}</td>
                </tr>
              )}

              {isCognito &&
                evidence_of_insurance_form.second_mortgage_clause !== null &&
                evidence_of_insurance_form.second_mortgage_clause.length >
                  0 && (
                  <tr>
                    <th>Lender</th>
                    <td className={'pb-3'}>
                      {nl2br(evidence_of_insurance_form.second_mortgage_clause)}
                    </td>
                  </tr>
                )}
              {props.entity.mortgage_id_2 !== null &&
                props.entity.second_mortgage !== null && (
                  <tr>
                    <th>Lender</th>
                    <td className={'pb-3'}>
                      <LenderPreview
                        {...props.entity.second_mortgage}
                        link={true}
                      />
                    </td>
                  </tr>
                )}

              {props.entity.loan_number_3 !== null && (
                <tr>
                  <th className={'w-25'}>3rd Loan #</th>
                  <td>{props.entity.loan_number_3}</td>
                </tr>
              )}

              {isCognito &&
                evidence_of_insurance_form.third_mortgage_clause &&
                evidence_of_insurance_form.third_mortgage_clause.length > 0 && (
                  <tr>
                    <th>Lender</th>
                    <td className={'pb-3'}>
                      {nl2br(evidence_of_insurance_form.third_mortgage_clause)}
                    </td>
                  </tr>
                )}
              {props.entity.mortgage_id_3 !== null &&
                props.entity.third_mortgage !== null && (
                  <tr>
                    <th>Lender</th>
                    <td className={'pb-3'}>
                      <LenderPreview
                        {...props.entity.third_mortgage}
                        link={true}
                      />
                    </td>
                  </tr>
                )}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};
